import * as React from "react";
import EventDefinitionPriorityEnum from "logic/alerts/EventDefinitionPriorityEnum";
import PriorityName from "components/events/events/PriorityName";
import EventTypeLabel from "components/events/events/EventTypeLabel";
import StringUtils from "util/StringUtils";
import i18n from "i18n";
const extendPrioritySlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  return Object.entries(EventDefinitionPriorityEnum.properties).map(([value, { name }]) => {
    var _a;
    return {
      value,
      title: StringUtils.capitalizeFirstLetter(name),
      count: (_a = countsByValue.get(String(value))) != null ? _a : 0
    };
  });
};
const extendTypeSlices = (slices) => {
  const countsByValue = new Map(slices.map((slice) => [String(slice.value), slice.count]));
  const values = [
    { value: "true", title: i18n.t("alerts_types.alert", { ns: "events" }) },
    { value: "false", title: i18n.t("alerts_types.event", { ns: "events" }) }
  ];
  return values.map(({ value, title }) => {
    var _a;
    return {
      value,
      title,
      count: (_a = countsByValue.get(value)) != null ? _a : 0
    };
  });
};
const sliceRenderers = {
  priority: {
    extendSlices: extendPrioritySlices,
    render: ({ value }) => /* @__PURE__ */ React.createElement(PriorityName, { priority: value })
  },
  alert: {
    extendSlices: extendTypeSlices,
    render: ({ value }) => /* @__PURE__ */ React.createElement(EventTypeLabel, { isAlert: String(value) === "true" })
  }
};
export default sliceRenderers;
